<ng-container>
  <header class="dialog__header">
    <h2 class="dialog__title">Requirements Settings</h2>
  </header>
  <mat-dialog-content
    class="requirements-settings-dialog"
    fxLayout="column"
  >
    <mat-tab-group class="requirements-settings-dialog__tabs">
      <mat-tab
        class="requirements-settings-dialog__tab-content"
        label="Commercial"
      >
        <requirements-fields-sorting-group
          [requirements]="commercial"
          [customSelected]="control.value?.values?.commercial"
          [formFields]="formFields"
          (selectedChanged)="onSelectedChanged($event, 'commercial')"
        />
      </mat-tab>
      <mat-tab
        class="requirements-settings-dialog__tab-content"
        label="Technical"
      >
        <requirements-fields-sorting-group
          [requirements]="technical"
          [customSelected]="control.value?.values?.technical"
          [formFields]="formFields"
          (selectedChanged)="onSelectedChanged($event, 'technical')"
        />
      </mat-tab>
      <mat-tab
        class="requirements-settings-dialog__tab-content"
        label="Logistical"
      >
        <requirements-fields-sorting-group
          [requirements]="logistical"
          [customSelected]="control.value?.values?.logistical"
          [formFields]="formFields"
          (selectedChanged)="onSelectedChanged($event, 'logistical')"
        />
      </mat-tab>
    </mat-tab-group>
  </mat-dialog-content>
  <footer class="dialog__footer">
    <button
      type="button"
      procure-button
      variant="stroked"
      (click)="onCancel()"
    >
      Cancel
    </button>
    <button
      type="submit"
      procure-button
      color="primary"
      [disabled]="
        selected.commercial?.length === 0 && selected.technical?.length === 0 && selected.logistical?.length === 0
      "
      (click)="onSubmit()"
    >
      Apply Changes
    </button>
  </footer>
</ng-container>
